import React from 'react';
import {
  Route,
  Redirect
} from "react-router-dom";

import store from '@store/store'
import ac from '@modules/access-control/access-control.service'
import AccessDenied from '@scenes/AccessDenied/AccessDenied'
import AuthService from '@modules/auth/auth.service'

class PrivateRoute extends React.Component {

  allowed(permissions) {

    if(!permissions) return true;

    permissions = typeof permissions === 'string' ? [permissions] : permissions;

    const currentUser = store.getState().auth.user;

    return permissions.reduce((allowed, permission) => {
      const [perm, resource] = permission.split(':');
      return allowed && ac.can(currentUser.role)[perm](resource).granted;
    }, true)

  }

  render() {
    const { component: Component, permissions, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={props => {

          if(!AuthService.isAuthenticated()) {
            const redirectTo = {
              pathname: "/login",
              state: { from: props.location }
            }
            return (<Redirect to={redirectTo} />)
          }


          // check permissions
          if(this.allowed(permissions)) {
            return (<Component {...props} />)
          } else {
            return (<AccessDenied />)
          }

        }}
      />
    )

  }
}

export default PrivateRoute


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.jsx